/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-common-lib
 * ============================================================================
 */

/**
 * @migrated-to academy-common-lib
 * @deprecated
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */

/**
 * @migrated-to academy-common-lib
 * @deprecated
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */

/**
 * @migrated-to academy-common-lib
 * @deprecated
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */

/**
 * @migrated-to academy-common-lib
 * @deprecated
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const isPlaylistItemType = type => {
  if (typeof type !== 'string') return false;
  return ['LESSON', 'TRACK', 'SHORT_FORM_CONTENT'].includes(type);
};

/**
 * @migrated-to academy-common-lib
 * @deprecated
 * This file has been migrated to academy-common-lib.
 * Canonical source: academy-common-lib/static/js/features/playlistItems/playlistItemsTypes.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-common-lib. All changes should be made in
 * academy-common-lib first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const toPlaylistItemType = type => {
  switch (type) {
    case 'COURSE':
      return 'TRACK';
    case 'TRACK':
    case 'LESSON':
    case 'SHORT_FORM_CONTENT':
      return type;
    case 'PLAYLIST':
    case 'LEARNING_PATH':
      return null;
    default:
      return null;
  }
};